// extracted by mini-css-extract-plugin
export default {"root":"Orders_root__ba0u6","headerBar":"Orders_headerBar__s3sAB","headerText":"Orders_headerText__N6M8q","layout":"Orders_layout__vdQv7","main":"Orders_main__6Owfp"};